var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"zov-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.outClasses},[_c('div',{class:_vm.Classes,style:(_vm.style)})])])}
var staticRenderFns = []

export { render, staticRenderFns }